import {registration} from "../modules/register";

export default {
  init: function () {
    registration();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/register.js